<template>
  <tbody>
    <tr>
      <td class="col-1">
        <div class="d-flex">
          <p>{{ criterio.sequencia == 0 ? 1 : criterio.sequencia }}</p>
          <dropdown-padrao
            text
            color="secondary"
          >
            <template #botao>
              <v-icon> $dotsVertical </v-icon>
            </template>

            <v-list-item-group style="overflow-y: auto">
              <v-list-item
                class="d-flex min-height-drop-item"
                @click="excluir(criterio)"
              >
                <v-icon>$mdiTrashCanOutline</v-icon>
                {{ $t('geral.botoes.excluir') }}
              </v-list-item>
            </v-list-item-group>
          </dropdown-padrao>
        </div>
      </td>
      <td class="col-1 mt-10">
        <v-select
          v-model="criterio.operadorLogico"
          :items="opcoes.operadorLogico"
          dense
          hide-details
          sem-label
          :clearable="false"
          :outlined="true"
          flat
          solo
          estilo-customizado="height: 50px"
        />
      </td>

      <td>
        <v-row class="ml-0">
          <v-select
            v-model="criterio.tipoCriterio"
            :items="tiposCriterio"
            dense
            hide-details
            outlined
            append-inner-icon="mdi-magnify"
            clearable
            class="col-8 pt-0 pb-0"
            @change="onTipoCriterioChange"
          />
          <campo-adicional-instrumentos
            v-if="criterio.tipoCriterio == 'CampoAdicionalInstrumento'"
            class="col-4 pt-0 pb-0"
            :criterio="criterio"
            @retornoValores="setCampoAdicionalInstrumentoId"
          />
          <campo-adicional-participantes
            v-if="criterio.tipoCriterio == 'CampoAdicionalParticipante'"
            class="col-4 pt-0 pb-0"
            :criterio="criterio"
            :entidade="'Participantes'"
            @retornaCampoAdicionalParticipanteId="setCampoAdicionalParticipanteId"
          />
        </v-row>
      </td>

      <td>
        <v-select
          v-model="criterio.operadorRelacional"
          :items="criteriosConfiguracoes[criterio.tipoCriterio]?criteriosConfiguracoes[criterio.tipoCriterio].operadores:''"
          item-value="value"
          item-title="text"
          hide-details
          dense
          outlined
          append-inner-icon="mdi-magnify"
          clearable
        />
      </td>

      <td>
        <component
          :is="campoSelecionado"
          v-if="campoSelecionado"
          v-model="criterio.valor"
          v-bind="getComponentProps(campoComponente)"
          :criterio="criterio"
        />
        <v-select v-else />
      </td>
    </tr>
  </tbody>
</template>

<script>
import { VSelect, VTextField, VBtn, VIcon, VAutocomplete } from 'vuetify/lib';
import TipoCalibracaoService from '@common/services/cadastros/TipoCalibracaoService';
import LocalExecucaoService from '../../../../../common/services/cadastros/LocalExecucaoService';
import ServicoCalibracaoTipoCalibracao from './inputs/ServicoCalibracaoTipoCalibracao.vue';
import LocalExecucao from './inputs/LocalExecucao.vue';
import TipoContrato from './inputs/TipoContrato.vue';
import RequisitoParticipante from './inputs/RequisitoParticipante.vue'
import TipoModeloInstrumentoModal from '../../servico_calibracao/components/modais/TipoModeloInstrumentoModal';
import {
  InputLaboratorio,
} from '@components/inputs';
import InstrumentoModal from '@/views/modulos/cadastros/ordem_servico/components/modais/InstrumentoModal.vue';
import TipoInstrumento from './inputs/TipoInstrumento.vue'
import TipoOrcamento from './inputs/TipoOrcamento.vue'
import ServicoManutencao from './inputs/ServicoManutencao.vue'
import Peca from './inputs/Peca.vue'
import Participante from './inputs/ParticipanteContaAdicional.vue';
import TotalOrcamento from './inputs/TotalOrcamento.vue';
import AdicionalInstrumento from './inputs/AdicionalInstrumento.vue';
import AdicionalParticipante from './inputs/AdicionalParticipante.vue';
import CampoAdicionalInstrumento from './inputs/CampoAdicionalInstrumento.vue'
import ParticipanteConta from './inputs/ParticipanteConta.vue'
import ParticipanteContaAdicional from './inputs/ParticipanteContaAdicional.vue'
import ServicoCalibracao from './inputs/ServicoCalibracao.vue'
import CampoAdicionalInstrumentos from './inputs/CampoAdicionalInstrumentos.vue'
import CampoAdicionalParticipantes from './inputs/CampoAdicionalParticipantes.vue'

export default {
    components: {
        VAutocomplete,
        VSelect,
        VTextField,
        VBtn,
        VIcon,
        ServicoCalibracaoTipoCalibracao,
        LocalExecucao,
        TipoContrato,
        RequisitoParticipante,
        TipoModeloInstrumentoModal,
        InputLaboratorio,
        InstrumentoModal,
        TipoInstrumento,
        TipoOrcamento,
        ServicoManutencao,
        Peca,
        Participante,
        TotalOrcamento,
        AdicionalInstrumento,
        AdicionalParticipante,
        CampoAdicionalInstrumento,
        ParticipanteConta,
        ParticipanteContaAdicional,
        ServicoCalibracao,
        CampoAdicionalInstrumentos,
        CampoAdicionalParticipantes
    },
    props: {
      criterio: Object,
      opcoes: Object,
      form: Object,
    },
    data() {
      return {
        showModalTipoServicoManutencao: false,
        tipoServicoManutencaoSelecionados: [],
        campoAdicionalInstrumentoId: null,
        showModal: false,
        tabela: {
          chave: 'id',
          selecionados: [],
          headers: [
            {
              text: this.$t('modulos.item.tabela.modelos_instrumentos'),
              align: 'start',
              value: 'modeloInstrumento.nome',
              groupable: false,
            },
            {
              text: this.$t('modulos.item.tabela.tipos_instrumentos'),
              align: 'start',
              value: 'tipoInstrumento.nome',
            },
          ],
          itens: {
            tipos: [],
            modelos: [],
          },
        },
        tiposCriterio: [
          {text:"Serviço de Calibração", value: "ServicoCalibracao"},
          {text:"Serviço de Calibração com Tipo de Calibração", value: "TipoCalibracao"},
          {text:"Serviço de Calibração em Contrato com Tipo de Contrato", value: "TipoContrato"},
          {text:"Serviço de Manutenção", value: "ServicoManutencao"},
          {text:"Peça", value: "Item"},
          {text:"Local de execução", value: "LocalExecucao"},
          {text:"Participante da conta", value: "ParticipanteConta"},
          {text:"Total do Orçamento", value: "ValorTotalOrcamento"},
          {text:"Tipo de Orçamento", value: "TipoOrcamento"},
          {text:"Tipo de Instrumento", value: "TipoInstrumento"},
          {text:"Campo adicional do Instrumento", value: "CampoAdicionalInstrumento"},
          {text:"Campo adicional do Participante", value: "CampoAdicionalParticipante"},
          {text:"Requisito do Participante", value: "RequisitoParticipante"}
        ],
        criteriosConfiguracoes: {
          "ServicoCalibracao": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "servico-calibracao",
            "valores": []
          },
          "TipoCalibracao": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "servico-calibracao-tipo-calibracao",
            "valores": [
              { text: "K1031", value: "K1031" },
              { text: "RBC", value: "RBC" },
              { text: "Outro", value: "Outro" }
            ]
          },
          "TipoContrato": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "tipo-contrato",
            "valores": []
          },
          "ServicoManutencao": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "servico-manutencao",
            "valores": [
              { text: "Sim", value: "Sim" },
              { text: "Não", value: "Nao" },
              { text: "Não se aplica", value: "Nao_se_aplica" }
            ]
          },
          "RequisitoParticipante": {
            "operadores": [
              { text: "Igual", value: "Igual" },
              { text: "Diferente", value: "Diferente" }
            ],
            "tipoCampo": "requisito-participante",
            "valores": [
              { text: "Sim", value: "Sim" },
              { text: "Não", value: "Nao" },
              { text: "Não se aplica", value: "Nao_se_aplica" }
            ]
          },
          "LocalExecucao": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "local-execucao",
            "valores": []
          },
          "ParticipanteConta": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "participante-conta",
            "valores": []
          },
          "ValorTotalOrcamento": {
            "operadores": [
              { text: "Igual", value: "Igual" },
              { text: "Maior", value: "Maior" },
              { text: "Maior ou Igual", value: "MaiorIgual" },
              { text: "Menor ou Igual", value: "MenorIgual" },
              { text: "Menor", value: "Menor" }
            ],
            "tipoCampo": "total-orcamento",
            "valores": []
          },
          "TipoOrcamento": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "tipo-orcamento",
            "valores": [
              { text: "Sim", value: "sim" },
              { text: "Não se aplica", value: "nao_se_aplica" }
            ]
          },
          "TipoInstrumento": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "tipo-instrumento",
            "valores": [
              { text: "Sim", value: "Sim" },
              { text: "Não", value: "Nao" },
              { text: "Não se aplica", value: "Nao_se_aplica" }
            ]
          },
          "CampoAdicionalInstrumento": {
            "operadores": [
              { text: "Igual", value: "Igual" },
              { text: "Maior", value: "Maior" },
              { text: "Menor ou Igual", value: "MenorIgual" },
              { text: "Menor", value: "Menor" }
            ],
            "tipoCampo": "adicional-instrumento",
            "valores": [
              { text: "Sim", value: "Sim" },
              { text: "Não", value: "Nao" },
              { text: "Não se aplica", value: "Nao_se_aplica" }
            ]
          },
          "CampoAdicionalParticipante": {
            "operadores": [
              { text: "Igual", value: "Igual" },
              { text: "Maior", value: "Maior" },
              { text: "Menor ou Igual", value: "MenorIgual" },
              { text: "Menor", value: "Menor" }
            ],
            "tipoCampo": "adicional-participante",
            "valores": [
              { text: "Sim", value: "Sim" },
              { text: "Não", value: "Nao" },
              { text: "Não se aplica", value: "Nao_se_aplica" }
            ]
          },
          "Item": {
            "operadores": [{ text: "Igual", value: "Igual" }],
            "tipoCampo": "peca",
            "valores": [
              { text: "Sim", value: "Sim" },
              { text: "Não", value: "Nao" },
              { text: "Não se aplica", value: "Nao_se_aplica" }
            ]
          }
        },
        listaLocalExecucao: [],
        operadoresRelacionaisFiltrados: [],
        campoComponente: null,
        valoresPossiveis: [],
        tiposCalibracao: [],
        teste:'',
        campoSelecionado: null
      };
    },
    computed: {
      operadorLogico() {
        return this.$store.getters['criterios/getCriterios'][this.criterio.sequencia].operadorLogico??false
      },
      erroOperadorLogico(){
        return this.$store.getters['criterios/getCriterios'][this.criterio.sequencia].operadorLogico? true :false
      },
    },
    watch: {
      'criterio.tipoCriterio': {
        handler(newValue) {
          this.campoSelecionado  = this.criteriosConfiguracoes[newValue]
            ? this.criteriosConfiguracoes[newValue].tipoCampo
            : '';
        },
        deep: true
      }
    },
    async mounted() {
      await this.setup()
    },
    methods: {
      async setup() {
        await this.buscarTiposCalibracao()
        this.campoSelecionado  = this.criteriosConfiguracoes[this.criterio.tipoCriterio]
            ? this.criteriosConfiguracoes[this.criterio.tipoCriterio].tipoCampo
            : '';
      },
      setCampoAdicionalInstrumentoId(criterio) {
        this.criterio.campoAdicionalInstrumentoId = criterio.tipoInstrumento
        this.criterio.campoAdicionalParticipanteId = null
        this.criterio.tipoInstrumento = null
        this.criterio.campoAdicionalInstrumento = {
          id: criterio.tipoInstrumento,
          nome: null
        }
      },
      setCampoAdicionalParticipanteId(criterio) {
          if (criterio.participanteContaId) {
            this.criterio.campoAdicionalParticipanteId = criterio.participanteContaId
            this.criterio.participanteContaId = null
            this.criterio.campoAdicionalInstrumentoId = null
            this.criterio.valor = criterio.valor
          }
      },
      associarInstrumentos(instrumentos) {
        this.form.instrumentos = [];
        instrumentos.forEach((instrumento) => {
            this.form.instrumentos.push({
                ...instrumento,
                instrumentoId: instrumento.id,
                codigo: instrumento.codigo,
                participante: instrumento.participanteCliente,
            });
        });
        this.form.ordensServicosInstrumentos = this.form.instrumentos;
      },
      closeModal() {
        this.showModal = false;
      },
      abrirNovo: function () {
        this.tabela.itens.modelos =
          this.form.itemTipoInstrumentoModeloInstrumento.map((item) => {
            if (!item.modeloInstrumento) return;
            return {
              id: item.modeloInstrumento.id,
              nome: item.modeloInstrumento.nome,
              tipoInstrumento: item.tipoInstrumento,
            };
          });
        this.tabela.itens.tipos =
          this.form.itemTipoInstrumentoModeloInstrumento.map(
            (item) => item.tipoInstrumento
          );
        this.showModal = true;
      },
      changeModalStep(value) {
        if (value.step === 'last') {
          this.form.itemTipoInstrumentoModeloInstrumento = [];
          value.tipos.forEach((tipo) => {
            const modelos = value.modelos.filter(
              (el) => el.tipoInstrumento.id === tipo.id
            );

            if (!modelos?.length) {
              this.form.itemTipoInstrumentoModeloInstrumento.push({
                tipoInstrumentoId: tipo.id,
                tipoInstrumento: {
                  id: tipo.id,
                  nome: tipo.nome,
                },
                modeloInstrumentoId: null,
                modeloInstrumento: null,
              });
            }

            modelos?.forEach((modelo) => {
              this.form.itemTipoInstrumentoModeloInstrumento.push({
                tipoInstrumentoId: tipo.id,
                tipoInstrumento: {
                  id: tipo.id,
                  nome: tipo.nome,
                },
                modeloInstrumentoId: modelo.id,
                modeloInstrumento: {
                  id: modelo.id,
                  nome: modelo.nome,
                },
              });
            });
          });
        } else {
          this.form.itemTipoInstrumentoModeloInstrumento = [];
        }
        this.closeModal();
      },
      buscarTiposCalibracao() {
        TipoCalibracaoService.listar().then((res) => {
          this.tiposCalibracao = res.data;
        });
      },
      async buscarLocalExecucaoService() {
        try {
          if (!this.listaLocalExecucao.length) {
            const response = await LocalExecucaoService.listar();

            if (response && response.data) {
              return this.formatForVuetifySelect(response.data, 'nome', 'id');

            } else {
              console.warn('A resposta do serviço não contém dados ou a estrutura não é a esperada.', response);
              return [];
            }

          }
        } catch (error) {
          console.error('Erro ao buscar dados do serviço de Local de Execução:', error);
          return [];
        }
      },
      async getComponentProps(componentType) {
        switch (componentType) {
          case 'v-select':{
            return {
              itemText: 'v-select',
              items: this.valoresPossiveis??[],
              dense: true,
              outlined: true,
              appendInnerIcon: 'mdi-magnify',
              clearable: true
            }
          }
          case 'v-autocomplete':
            return {
                items: this.valoresPossiveis??[],
                dense: true,
                filled: true,
                rounded: true,
                solo: true,
                appendIcon: 'pi pi-search',
                clearable: true
            };
          case 'v-text-field':
            return {
              dense: true,
              outlined: true,
              items: [],
            };
          default:
            return {};
        }
      },
      formatForPrimeVueDropdown(dataArray, labelField, valueField) {
        return dataArray.map(item => ({
          label: item[labelField],
          value: item[valueField]
        }));
      },
      formatForVuetifySelect(dataArray, labelField, valueField) {
        return dataArray.map(item => ({
          text: item[labelField],
          value: item[valueField]
        }));
      },
      async updateConfiguracoes(tipoCriterio) {
        const config = await this.criteriosConfiguracoes[tipoCriterio];
        if (config) {
          this.operadoresRelacionaisFiltrados = config.operadores || [];
          this.campoComponente = config.tipoCampo;
        } else {
          this.operadoresRelacionaisFiltrados = [];
          this.campoComponente = "v-text-field";
          this.valoresPossiveis = [];
        }
      },
      formatForPrimeVueSelect(dataArray, labelField, valueField) {
        return dataArray.map(item => ({
          label: item[labelField],
          value: item[valueField]
        }));
      },
      async onTipoCriterioChange(value) {
        this.$store.dispatch('criterios/validarCriterios')
        await this.updateConfiguracoes(value);
      },
      excluir(criterio){
        this.$store.dispatch('criterios/deleteCriterio', {deleteCriterio: criterio});
      }
    }
  };
  </script>
  <style scoped>
  .custom-icon .pi-search {
    animation: none;
    transform: none;
  }
  th{
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
  }
  .th-simple-table{
    height: 50px;
    color: rgba(0, 0, 0, .6);
    user-select: none;
    font-size: .75rem;
    height: 48px;
    border-left: 1px solid #dddddd;
  }
  td{
    padding: 0px 10px;
  }
  td div{
    justify-content: center;
    animation: c;
    align-items: baseline;

    padding: 4px 0px;
  }
  .v-text-field__details{
    display: none !important;
  }
  .row{
    justify-content: center;
    align-items: center;
  }
  </style>
